<template>
    <div>
        <h2>Cerrando sesión...</h2>
    </div>
</template>

<script>
    export default {
        name: "Logout",
        mounted() {
            this.$store.dispatch('login/removeUser');
            this.$router.push("/login");
        }
    }
</script>

<style scoped>

</style>